const platformCapabilitiesToSku = {
    mini: "ATT-MINI",
    att2: "ATT-2",
    att4: "ATT-4",
    att6: "ATT-6",
    att8: "ATT-8",
}

export default {
    platformCapabilitiesToSku
};
